import { MutationTree } from "vuex";
import { HomeState } from ".";
import { SportEvent } from "../../models/sport-events.model";
import { PaginationResponse } from "./../../models/pagination.model";
import { Statistics } from "./../../models/statistics.model";

const MAIN_SPORT_EVENTS_COUNT = 6;

export const HomeMutationTypes = {
  SetMainSportEvents: "SET_MAIN_SPORT_EVENTS",
  SetSportEventsList: "SET_SPORT_EVENTS_LIST",
  SetStatistics: "SET_STATISTICS"
};

export const mutations: MutationTree<HomeState> = {
  [HomeMutationTypes.SetMainSportEvents](state: HomeState, payload: PaginationResponse<SportEvent[]>) {
    state.mainSportEvents = payload.data.slice(0, MAIN_SPORT_EVENTS_COUNT);
  },
  [HomeMutationTypes.SetSportEventsList](state: HomeState, payload: PaginationResponse<SportEvent[]>) {
    state.sportEventsList = payload.data;
  },
  [HomeMutationTypes.SetStatistics](state: HomeState, payload: Statistics) {
    state.statistics = payload;
  }
};
